<script>
import { mergeData } from 'vue-functional-data-merge'
import { QBtnDropdown } from 'quasar'

export default {
  functional: true,
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    outline: {
      type: Boolean,
      default: true
    }
  },
  render (createElement, { props, data, children }) {
    return createElement(QBtnDropdown, mergeData({
      props: {
        color: props.color,
        outline: props.outline
      }
    }, data), children)
  }
}
</script>
